"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isNodeEqual = function (n1, n2) {
    if (n1.hasOwnProperty('__id') && n2.hasOwnProperty('__id')) {
        var first = n1.__id === n2.__id;
        if (!first) {
            return false;
        }
        if (n1.hasOwnProperty('__call') && n2.hasOwnProperty('__call')) {
            return n1.__call === n2.__call;
        } else {
            return true;
        }
    } else {
        return n1 === n2;
    }
};
exports.replace = function (node, before, after) {
    var found = false;
    var go = function go(n) {
        if (found) {
            return n;
        }
        if (exports.isNodeEqual(n, before)) {
            found = true;
            return after;
        }
        if (n.type === 'CallExpression') {
            return Object.assign({}, n, { callee: go(n.callee), arguments: n.arguments.map(go) });
        } else if (n.type === 'ConditionalExpression') {
            return Object.assign({}, n, { test: go(n.test), consequent: go(n.consequent), alternate: go(n.alternate) });
        } else if (n.type === 'UnaryExpression') {
            return Object.assign({}, n, { argument: go(n.argument) });
        } else if (n.type === 'BinaryExpression' || n.type === 'LogicalExpression') {
            return Object.assign({}, n, { left: go(n.left), right: go(n.right) });
        } else {
            return n;
        }
    };
    return go(node);
};
var mkLiteralNode = function mkLiteralNode(value) {
    if (typeof value === 'undefined') {
        return {
            type: 'Identifier',
            name: 'undefined',
            __id: freshId()
        };
    } else {
        return {
            type: 'Literal',
            value: value,
            raw: value,
            __id: freshId()
        };
    }
};
var freshId = function () {
    var id = 0;
    return function () {
        id++;
        return '__syn' + id;
    };
}();
exports.createNode = function (value) {
    if (value && value.node && value.constructor && value.constructor.name === 'Closure') {
        return value.node;
    }
    return mkLiteralNode(value);
};
//# sourceMappingURL=astUtils.js.map


//////////////////
// WEBPACK FOOTER
// ../source-toolchain/es5/astUtils.js
// module id = 122
// module chunks = 3